<template>
  <keep-alive>
    <component :is="component" :accessKey="accessKey" @dataInput="onInput" @compSignal="processCompSignal" v-if="component" ></component>
  </keep-alive>
</template>

<script>
export default {
  name: 'sysReferenceView',
  props: ['type', 'accessKey'],
  data () {
    return {
      component: null,
      val: undefined
    }
  },
  computed: {
    loader () {
      if (!this.type) {
        return null
      }
      return () => import('@/components/modules/references/' + this.type)
    }
  },
  methods: {
    onInput (val) {
      console.log('onInput event ', val)
    },
    processCompSignal (signal) {
      console.log('refView retransmits compSignal', signal)
      this.$emit('compSignal', signal)
    }
  },
  mounted () {
    const self = this
    this.loader()
      .then(() => {
        self.component = () => self.loader()
      })
      .catch(() => {
        this.component = () => import('@/components/modules/references/notfound')
      })
  }
}
</script>
